export default __webpack_public_path__ + "static/media/icon_share.88886c6c.png";